import { FunctionComponent } from 'react';

import { FileSummary } from '@savgroup-front-common/types';

import { FileStateHistorySummary } from '@/api/Workflow/getFileStatesQuery';

import ProductInfoHeader from '../ProductInfoHeader/ProductInfoHeader';
import ProductInfoHistory from '../ProductInfoHistory/ProductInfoHistory';
import { ProductsInfoMinimal } from '../ProductsInfo.types';

import { $Card, $CardContent, $Divider } from './MonoProductInfo.styles';
import MonoProductInfoDescription from './MonoProductInfoDescription/MonoProductInfoDescription';

const MonoProductInfo: FunctionComponent<{
  fileInfo?: FileSummary;
  productInfo?: ProductsInfoMinimal;
  histories?: FileStateHistorySummary[];
  hasCreatedDate?: boolean;
  hasHistory?: boolean;
  hasOpenProductButton?: boolean;
  onClick?: () => void;
}> = ({
  fileInfo,
  productInfo,
  histories = [],
  hasCreatedDate = false,
  hasHistory = false,
  hasOpenProductButton = false,
  onClick,
}) => {
  return (
    <$Card
      minimal
      elevation={2}
      onClick={onClick}
      isCliquable={!!onClick}
      withoutMarginBottom
    >
      <ProductInfoHeader
        fileInfo={fileInfo}
        productInfo={productInfo}
        hasCreatedDate={hasCreatedDate}
        hasOpenProductButton={hasOpenProductButton}
        onClick={onClick}
      />
      <$Divider />
      <$CardContent>
        {productInfo && (
          <MonoProductInfoDescription productInfo={productInfo} />
        )}
        {hasHistory && <ProductInfoHistory histories={histories} />}
      </$CardContent>
    </$Card>
  );
};

MonoProductInfo.displayName = 'MonoProductInfo';
export default MonoProductInfo;
